import { store } from "../Pages/ReduxStore/store";
import { toast } from "react-toastify";
import { defaultInfo } from "../ConfigInfo/Info";

export const isFileSizeAllowed = (file) => {
  if (!file) return true;
  const loginInfo = store.getState().auth.loginInfo || {};
  if (loginInfo.roleId === defaultInfo.OrgAdmin.id) return true;

  const maxFileSize = Number(loginInfo.maxFileSize);
  if (!maxFileSize || maxFileSize <= 0) return true;

  if (file.size > maxFileSize * 1024 * 1024) {
    toast.error(`File size should not exceed ${maxFileSize} MB`);
    return false;
  }
  return true;
};
